<web-settings-breadcrumbs *ngIf="showFullSettings">
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "analytics_form_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>
<div [class]="showFullSettings ? 'panel-options-body overflow-wrapper' : 'form-row'">
    <ng-container *ngrxLet="websiteSettings$; let settings">
        <div class="mb-20">
            <div class="form-group mb-10 form-horizontal row">
                <ng-container *ngIf="settings?.google_analytics; else withoutGoogleSwitcher">
                    <div [class]="isShopCart ? 'col-xs-12' : 'col-xs-9'">
                        <label>
                            {{ "google_analytic_label" | translate }}
                        </label>
                        <p class="analytic-hint small text-muted mb-0">
                            {{ "how_setting" | translate }}
                            <a [href]="helpGALink" target="_blank">
                                {{ "info_google_link" | translate }}
                                <img
                                    class="font-icon-light"
                                    src="./assets/img/websites/lpc-new-window-icon.svg"
                                    alt="new-window-icon"
                                />
                            </a>
                        </p>
                    </div>
                    <div *ngIf="!isShopCart" class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="googleAnalyticControl.value"
                            (toggleActiveEvent)="toggleGoogleAnalyticControl($event)"
                        ></sp-switch>
                    </div>
                </ng-container>

                <ng-template #withoutGoogleSwitcher>
                    <div class="col-xs-12">
                        <label>
                            {{ "google_analytic_label" | translate }}
                        </label>
                        <p class="analytic-hint small text-muted mb-0">
                            {{ "google_analytic_description" | translate }}
                            <a [href]="helpGALink" target="_blank">
                                {{ "how_setting_product" | translate }}
                                <img
                                    class="font-icon-light"
                                    src="./assets/img/websites/lpc-new-window-icon.svg"
                                    alt="new-window-icon"
                                />
                            </a>
                        </p>
                    </div>
                </ng-template>
            </div>
            <web-google-settings
                *ngIf="googleAnalyticControl.value && !isPaymentForm && !isShopCart"
                [googleSettings]="googleGoogleSettingsGroup"
                [class]="showFullSettings ? '' : 'negative-indents-wrap'"
            >
            </web-google-settings>

            <div *ngIf="googleAnalyticControl.value && isPaymentForm" class="well well-sm mb-10">
                <small [innerHtml]="'google_analytic_in_payment_hint' | translate"></small>
            </div>

            <div class="form-group mb-10 form-horizontal row" *ngIf="isShopCart">
                <div class="control-label col-xs-9">{{ "analytics_control_before_send" | translate }}</div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="googleAnalyticControl.value"
                        (toggleActiveEvent)="toggleGoogleAnalyticControl($event)"
                    ></sp-switch>
                </div>
            </div>
            <div *ngIf="googleAnalyticControl.value && isShopCart" class="well well-sm mb-10">
                <small [innerHtml]="'google_analytic_before_payment_cart_hint' | translate"></small>
            </div>

            <div class="form-group form-horizontal row" *ngIf="isShopCart">
                <div class="control-label col-xs-9">{{ "analytics_control_after_send" | translate }}</div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [disabled]="isDisabledGoogleAnalyticAfterPaymentControl"
                        [active]="googleAnalyticAfterPaymentControl.value"
                        (toggleActiveEvent)="toggleGoogleAnalyticAfterPaymentControl($event)"
                    ></sp-switch>
                </div>
            </div>
            <div *ngIf="googleAnalyticAfterPaymentControl.value && isShopCart" class="well well-sm mb-10">
                <small [innerHtml]="'google_analytic_after_payment_cart_hint' | translate"></small>
            </div>
        </div>

        <hr *ngIf="isShopCart" class="panel-options-divider" />

        <div class="mb-0">
            <div class="form-group mb-10 form-horizontal row">
                <ng-container *ngIf="settings?.facebook_pixel; else withoutFacebookSwitcher">
                    <div [class]="isShopCart ? 'col-xs-12' : 'col-xs-9'">
                        <label>
                            {{ "facebook_analytic_label" | translate }}
                        </label>
                        <p class="analytic-hint small text-muted mb-0">
                            {{ "how_setting" | translate }}
                            <a [href]="helpPixelLink" target="_blank">
                                {{ "info_facebook_link" | translate }}
                                <img
                                    class="font-icon-light"
                                    src="./assets/img/websites/lpc-new-window-icon.svg"
                                    alt="new-window-icon"
                                />
                            </a>
                        </p>
                    </div>
                    <div *ngIf="!isShopCart" class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="pixelAnalyticControl.value"
                            (toggleActiveEvent)="togglePixelAnalyticControl($event)"
                        ></sp-switch>
                    </div>
                </ng-container>
                <ng-template #withoutFacebookSwitcher>
                    <div class="col-xs-12">
                        <label>
                            {{ "facebook_analytic_label" | translate }}
                        </label>
                        <p class="analytic-hint small text-muted mb-0">
                            {{ "facebook_analytic_description" | translate }}
                            <a [href]="helpPixelLink" target="_blank">
                                {{ "how_setting_product" | translate }}
                                <img
                                    class="font-icon-light"
                                    src="./assets/img/websites/lpc-new-window-icon.svg"
                                    alt="new-window-icon"
                                />
                            </a>
                        </p>
                    </div>
                </ng-template>
            </div>
            <ng-container *ngIf="pixelAnalyticControl.value && !isShopCart">
                <web-pixel-settings [pixelSettings]="pixelSettingsGroup"></web-pixel-settings>
            </ng-container>
            <div class="form-group mb-10 form-horizontal row" *ngIf="isShopCart">
                <div class="control-label col-xs-9">{{ "analytics_control_before_send" | translate }}</div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="pixelAnalyticControl.value"
                        (toggleActiveEvent)="togglePixelAnalyticControl($event)"
                    ></sp-switch>
                </div>
            </div>
            <ng-container *ngIf="pixelAnalyticControl.value && isShopCart">
                <web-pixel-settings [pixelSettings]="pixelSettingsGroup"></web-pixel-settings>
            </ng-container>
            <div class="form-group mb-10 form-horizontal row" *ngIf="isShopCart">
                <div class="control-label col-xs-9">{{ "analytics_control_after_send" | translate }}</div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [disabled]="isDisabledPixelAnalyticAfterPaymentControl"
                        [active]="pixelAnalyticAfterPaymentControl.value"
                        (toggleActiveEvent)="togglePixelAnalyticAfterPaymentControl($event)"
                    ></sp-switch>
                </div>
            </div>
            <ng-container *ngIf="pixelAnalyticAfterPaymentControl.value && isShopCart">
                <web-pixel-settings [pixelSettings]="pixelSettingsGroup" [isAfterPayment]="true"></web-pixel-settings>
            </ng-container>
        </div>
    </ng-container>
</div>
